import TopBar from "@/components/top-bar";
import TopBackSticky from "@/pages/daily-reward/components/TopBackSticky";
import { platform } from "@/utils/platform";
import React from "react";
import styles from "./index.module.less";

interface FloatingTopBarProps {
  isHideRight?: boolean;
  isSticky?: boolean;
}

/**
 * 浮动顶部导航栏组件,H5专用
 */
const FloatingTopBar: React.FC<FloatingTopBarProps> = ({ isHideRight = true, isSticky = false }) => {
  if (!platform.isH5) {
    return null;
  }

  const title = () => {
    return <div className={styles.titleview}>
      <img
        className={styles.img}
        src="https://akim-oss.aikucun.com/4a59601c8f6727f5ba6ec791e07a9417b0d1e346_1701867890366_22.png"
      />
      <div className={styles.text}>全场100%正品</div>
    </div>;

  };

  // 吸顶状态，返回吸顶导航栏(左侧返回按钮+home胶囊，中间全场100%正品)
  if (isSticky) {
    return (
      <div className={styles.custom_top_back_white}>
        <TopBar isHideRight={isHideRight} center={title()} isShowCenter={true} />
        <div></div>
      </div>
    );
  }
  // 非吸顶状态，只返回左上角回退+home胶囊
  return <TopBackSticky />;
};

export default FloatingTopBar;
